<template>
  <Modal
    :value="visible"
    :scrollable="true"
    :mask-closable="false"
    :closable="false"
    :transfer="false"
    width="560px"
    class-name="payment-remark"
    :footer-hide="true"
    @on-cancel="handleCancel">
    <div class="payment-remark__header flex flex--align-center flex--justify-between">
      <h2>添加备注</h2>
      <div class="actions">
        <v-icon type="icondone-24px"
                :class="remark ? '' : 'disabled'"
                @click.native="handleSave"></v-icon>
        <v-icon type="iconclear-24px"
                @click.native="handleCancel"></v-icon>
      </div>
    </div>
    <div class="payment-remark__body">
      <Input type="textarea"
             :rows="12"
             :resize="false"
             v-model="remark"
             placeholder="请输入备注"></Input>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'remark',
  props: {
    visible: Boolean,
  },
  data() {
    return {
      remark: '',
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.remark = '';
      }
    },
  },
  methods: {
    handleCancel() {
      this.$emit('update:visible', false);
    },
    handleSave() {
      if (this.remark) {
        this.$emit('on-save-remark', this.remark);
      }
    },
  },
};
</script>

<style lang="less">
  .payment-remark{
    display: flex;
    align-items: center;
    justify-content: center;
    &.ivu-modal-wrap{
      overflow: hidden;
    }
    &__header{
      padding: 8px 16px 0;
      h2{
        color: rgba(0, 0, 0, 0.54);
        font-size: 22px;
        line-height: 32px;
      }
      .v-icon{
        color: rgba(0, 0, 0, 0.54);
        margin-left: 24px;
        cursor: pointer;
        &:hover{
          color: @primary-color;
        }
        &.disabled{
          color: rgba(0, 0, 0, 0.12);
          cursor: no-drop;
          &:hover{
            color: rgba(0, 0, 0, 0.12);
          }
        }
      }
    }
    &__body{
      padding: 16px;
      .ivu-input{
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.12);
        box-shadow: none;
        padding: 8px 16px;
        color: rgba(0, 0, 0, 0.87);
        resize: none;
        line-height: 24px;
      }
    }
    .ivu-modal{
      width: 560px;
      top: 0;
      position: relative;
    }
    .ivu-modal-content{
      border-radius: 8px;
    }
    .ivu-modal-body{
      padding: 0;
    }
  }
</style>
